import type { EstadoCierre } from "./api";
import { Badge } from "../../components/ui";

// Pipeline de cierre: 10 estados. Usa el primitivo `Badge` pisando el color:
// cada fase lleva DOS TONOS (100 = "en proceso", 200 = "hecho") y eso no
// entra en los tonos planos del Badge (tailwind-merge resuelve el conflicto). Fases: prevalidación en neutral,
// cálculo en amber, facturación en brand, cerrado en emerald, bloqueado en
// rose. La forma es la misma que el Badge primitivo.
const COLORS: Record<EstadoCierre, string> = {
  ABIERTO: "bg-white text-neutral-700 ring-1 ring-inset ring-neutral-300",
  EN_PREVALIDACION: "bg-neutral-100 text-neutral-700",
  PREVALIDADO: "bg-neutral-200 text-neutral-800",
  BLOQUEADO: "bg-rose-100 text-rose-700",
  EN_CALCULO: "bg-amber-100 text-amber-800",
  CALCULADO: "bg-amber-200 text-amber-900",
  EN_FACTURACION: "bg-brand-100 text-brand-800",
  FACTURADO: "bg-brand-200 text-brand-900",
  // HOLD (revisión de supervisor): amber-300 lo distingue del par de
  // cálculo (amber-100/200) manteniéndolo en la familia "atención".
  HOLD: "bg-amber-300 text-amber-950",
  CERRADO: "bg-emerald-200 text-emerald-900",
};

/** Cómo lo dice la oficina, no el código del estado. */
export const ETIQUETA_ESTADO: Record<EstadoCierre, string> = {
  ABIERTO: "Abierto",
  EN_PREVALIDACION: "Revisando lecturas",
  PREVALIDADO: "Lecturas revisadas",
  BLOQUEADO: "Bloqueado",
  EN_CALCULO: "Calculando",
  CALCULADO: "Calculado",
  EN_FACTURACION: "Emitiendo boletas",
  FACTURADO: "Boletas emitidas",
  HOLD: "En revisión",
  CERRADO: "Cerrado",
};

export function EstadoBadge({ estado }: { estado: EstadoCierre }): JSX.Element {
  return (
    <span title={estado}>
      <Badge className={COLORS[estado]}>{ETIQUETA_ESTADO[estado]}</Badge>
    </span>
  );
}

export const MESES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
